import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then(res => setSettings(res.data))
      .catch(err => console.error('Settings laden fehlgeschlagen:', err))
      .finally(() => setLoading(false));
  }, []);

  return { settings, loading };
}
